const dateFmt = new Intl.DateTimeFormat("it-IT", { day: "numeric", month: "short", year: "numeric" });
const dateTimeFmt = new Intl.DateTimeFormat("it-IT", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
const euro = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" });

export const formatDate = (iso?: string) => (iso ? dateFmt.format(new Date(iso)) : "—");
export const formatDateTime = (iso?: string) => (iso ? dateTimeFmt.format(new Date(iso)) : "—");
export const formatEuro = (v?: number) => (v == null ? "—" : euro.format(v));
const qty = new Intl.NumberFormat("it-IT", { maximumFractionDigits: 2 });
export const formatQuantita = (v?: number) => (v == null ? "—" : qty.format(v));

/** "oggi", "ieri", "3 giorni fa" oppure la data. */
export function formatRelative(iso?: string): string {
  if (!iso) return "—";
  const d = new Date(iso);
  const days = Math.floor((startOfDay(new Date()) - startOfDay(d)) / 86_400_000);
  if (days <= 0) return "oggi";
  if (days === 1) return "ieri";
  if (days < 7) return `${days} giorni fa`;
  return dateFmt.format(d);
}
const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

/** Accetta "1.234,56", "1234.56", "€ 12" → numero, oppure undefined se vuoto/non valido. */
export function parseNumber(text: string): number | undefined {
  const t = text.replace(/[€\s]/g, "");
  if (!t) return undefined;
  const normalized = t.includes(",") ? t.replace(/\./g, "").replace(",", ".") : t;
  const n = Number(normalized);
  return Number.isFinite(n) ? n : undefined;
}

export const formatNumberInput = (v?: number) => (v == null ? "" : String(v).replace(".", ","));
